import { logError } from '@/utils/error-handling';
import { createClient, SupabaseClientOptions } from '@supabase/supabase-js';

// Obtener credenciales desde variables de entorno
// IMPORTANTE: Crear archivo .env.local con estas variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

// Validar que las variables de entorno estén configuradas
if (!supabaseUrl || !supabaseAnonKey) {
  const errorMessage = 'Faltan variables de entorno: VITE_SUPABASE_URL y VITE_SUPABASE_ANON_KEY. ' +
    'Por favor, crea un archivo .env.local con estas variables. ' +
    'Consulta .env.example para más información.';
  logError(new Error(errorMessage), 'Supabase.config', true);
  throw new Error(errorMessage);
}

// Helper para obtener el storage (localStorage en web)
const getStorage = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    return window.localStorage;
  }
  return undefined;
};

// Configuración del cliente Supabase
const supabaseOptions: SupabaseClientOptions<'public'> = {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // Siempre true en web
    storage: getStorage(),
    flowType: 'implicit', // Usar implicit flow en web
    storageKey: 'supabase.auth.token',
  },
  db: {
    schema: 'public',
  },
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
};

// Crear cliente con configuración optimizada
export const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseOptions);
